import { Fancybox } from '@fancyapps/ui';

function FancyboxModule(selector = '[data-fancybox]', options = {}) {
  Fancybox.bind(selector, {
    animated: false,
    showClass: false,
    Toolbar: {
      enabled: false,
    },
    ...options,
  });
}

export default FancyboxModule;
